import { observerSection } from "./observerSection";

export default () => {
    window.addEventListener('hashchange', () => {
        document.querySelectorAll('a')?.forEach(a => {
            a.classList.remove('active');
            if (a.getAttribute('href') === window.location.hash) {
                a.classList.add('active');
            }
        });
    });

    if (!document.querySelector('.product-anchors')) return
    const anchors = Array.from(document.querySelectorAll('.product-anchors ul li a') as NodeListOf<HTMLAnchorElement>)
    anchors[0].classList.add('active')

    const sections = anchors.map(anchor => document.querySelector(anchor.getAttribute('href') as string) as HTMLElement)

    observerSection(sections, anchors)
}
